import React from "react";
import { Box, Typography, Divider, Pagination } from "@mui/material";
import { CardsWrapper } from "./styles";
import { formatDate } from "../../../../utils/formatDate";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { AffiliateSale } from "../../../../store/services/affiliate/dto/affiliate.dto";

const AffiliateSalesCardsList = ({
	data,
	page,
	perPage,
	totalItems,
	onPageChange
}: {
	data: AffiliateSale[];
	page?: number;
	perPage?: number;
	totalItems?: number;
	onPageChange?: (page: number) => void;
}) => {
	return (
		<CardsWrapper>
			{(data || []).map(item => (
				<Box key={item.id} className={"card"}>
					<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
						<Typography fontWeight={"bold"}>Transaction ID</Typography>{" "}
						<Typography variant={"caption"}>{item.transactionId}</Typography>
					</Box>
					<Divider />
					<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
						<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>Sale Amount</Typography>
								<Typography>{formatCurrency(item.amount, item.currency)}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box display={"flex"} flexDirection={"column"}>
							<Typography fontWeight={"bold"}>Buyer</Typography>
							<Typography>{item.user.firstName + " " + item.user.lastName}</Typography>
						</Box>
						<Divider />
						<Box className={"card-footer"}>
							<Box display={"flex"} flexDirection={"column"} justifyContent={"fle"} alignItems={"flex-start"}>
								<Typography fontWeight={"bold"}>Invitation ID</Typography>
								<Typography variant={"caption"}>{item.invitationId}</Typography>
							</Box>
							<Typography>{formatDate(item.createdAt, "Africa/Cairo", "PP")}</Typography>
						</Box>
					</Box>
				</Box>
			))}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange && onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default AffiliateSalesCardsList;
